'use strict';

/*@ngInject*/
module.exports = function ($scope, $sce, roadElementsService, $rootScope, data, $uibModalInstance) {
    var vm = this;

    vm.roadElementId = data;
    vm.modalInstace = $uibModalInstance;

    $scope.$watch('vm.roadElementId', function (value) {
        if (value) {
            vm.roadElement = {};
            roadElementsService.getRoadElementDataById(vm.roadElementId).then(function (result) {
                return vm.roadElement = result.data;
            });
        }
    });

    vm.close = function () {
        vm.modalOpened = false;
        $rootScope.isModalOpen = false;
    };

    vm.trustedHtml = function (text) {
        return $sce.trustAsHtml(text);
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/road_elements/road-element-data-modal.directive.js
 **/